// @ts-nocheck

export const LocalStorageLineUpKeys = {
  SHOW_LINE_UP_NOTIFICATIONS_INFOS_POPUP: 'cache:betting:lineup:showLineUpNotificationsInfosPopup',
};
